import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service'; // add import

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private sessionStorageService: SessionStorageService  // inject service
  ) { }
  // Session Expiry Fix:
  // Skip token injection for public/authentication APIs and clear session data
  // on 401 responses to avoid stale token reuse during subsequent logins.

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // APIs that should NOT receive Authorization header
    const publicUrls = [
      '/login',
      '/forgot-password',
      '/reset-password',
      '/refresh-token'
    ];

    const isPublicRequest = publicUrls.some(url =>
      req.url.toLowerCase().includes(url.toLowerCase())
    );

    let authReq = req;

    // Add token only for protected APIs
    if (!isPublicRequest) {

      const token = this.sessionStorageService.getToken();

      if (token) {

        // FormData (file upload) must keep the browser generated multipart
        // Content-Type, otherwise the boundary is lost and the server cannot parse it.
        const headers: Record<string, string> = {
          Authorization: `Bearer ${token}`
        };

        if (!(req.body instanceof FormData)) {
          headers['Content-Type'] = 'application/json';
        }

        authReq = req.clone({ setHeaders: headers });
      }
    }

    return next.handle(authReq).pipe(

      catchError((error: HttpErrorResponse) => {

        if (error.status === 401) {

          // Clear session data
          this.sessionStorageService.clearSession();

          // Notify other tabs
          localStorage.setItem(
            'logout-event',
            Date.now().toString()
          );

          // Redirect to login
          this.router.navigate(['/login']);
        }

        if (error.status === 500) {
          console.error('Server Error:', error);
        }

        if (error.status === 400) {
          console.warn('Validation Error:', error);
        }

        return throwError(() => error);

      })

    );
  }


}
